import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

export interface EnergyPricePayload {
  startDate: string; // ISO string
  endDate: string; // ISO string
  energyType?: string; // 'electric' | 'gas'
  viewType?: string; // 'day' | 'week' | 'month' | 'year'
  volume?: string; // 'mWh' | 'kWh'
}

export interface FirstAvailableEnergyPriceDatePayload {
  requestedDate: string; // ISO string
  energyType?: string; // 'electric' | 'gas' | 'imbalance'
  viewType?: string; // 'day' | 'week' | 'month' | 'year'
  volume?: string; // 'mWh' | 'kWh'
}

@Injectable({
  providedIn: 'root',
})
export class EnergyPriceService {
  private readonly apiUrl = environment.enwyseApiUrl.replace(/\/+$/, '');
  private readonly httpClient = inject(HttpClient);

  getEnergyPrices(payload: EnergyPricePayload): Observable<any> {
    const url = `${this.apiUrl}/EnergyPrices`; // adjust endpoint if needed

    let params = new HttpParams()
      .set('startDate', payload.startDate)
      .set('endDate', payload.endDate)
      .set('energyType', payload.energyType!)
      .set('viewType', payload.viewType!)
      .set('volume', payload.volume!);

    return this.httpClient.get(url, { params: params }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching energy prices', error);
        return throwError(() => error);
      })
    );
  }

  getFirstAvailableEnergyPriceDate(payload: FirstAvailableEnergyPriceDatePayload): Observable<any> {
    const url = `${this.apiUrl}/EnergyPrices/first-available`;

    const params = new HttpParams()
      .set('requestedDate', payload.requestedDate)
      .set('energyType', payload.energyType ?? 'electric')
      .set('viewType', payload.viewType ?? 'day')
      .set('volume', payload.volume ?? 'mWh');

    return this.httpClient.get(url, { params }).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching first available energy price date', error);
        return throwError(() => error);
      })
    );
  }
}
